import React, { useState } from 'react';
import { Modal } from './ui/Modal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-teal py-12 border-t border-white/10" data-id="element-28">
        <div className="max-w-6xl mx-auto px-6 md:px-12 text-center" data-id="element-29">
          <p className="font-serif text-xl text-white mb-6" data-id="element-30">
            Protocolo Anti-Inflamatorio 40+
          </p>

          <p className="text-white/70 text-xs font-light max-w-2xl mx-auto leading-relaxed mb-6" data-id="element-31">
            Este producto no sustituye el asesoramiento profesional. Siempre
            consulte a un médico para tratar asuntos relacionados con su salud.
            Los resultados pueden variar de persona a persona.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-6" data-id="element-32">
            <button onClick={() => setOpenModal('privacy')} className="text-white/80 hover:text-gold transition-colors text-sm font-light tracking-wide" data-id="element-33">
              Política de Privacidad
            </button>
            <span className="text-white/30 text-xs" aria-hidden="true" data-id="element-34">
              •
            </span>
            <button onClick={() => setOpenModal('terms')} className="text-white/80 hover:text-gold transition-colors text-sm font-light tracking-wide" data-id="element-35">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-white/60 text-xs font-light" data-id="element-36">
            &copy; {new Date().getFullYear()} Protocolo Anti-Inflamatorio 40+.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-37">
        <p className="text-xs uppercase tracking-wider text-gold font-medium" data-id="element-38">
          Última actualización: Enero 2026
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-39">
          1. Información que recopilamos
        </h3>
        <p data-id="element-40">
          Al adquirir el Protocolo Anti-Inflamatorio 40+, podemos recopilar
          información personal básica necesaria para procesar tu compra y
          entregarte el material digital. Esto incluye nombre, dirección de
          correo electrónico y los datos de pago que son gestionados de forma
          exclusiva por la plataforma Hotmart bajo sus propios estándares de
          seguridad.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-41">
          2. Uso de la información
        </h3>
        <p data-id="element-42">
          La información recopilada se utiliza únicamente para entregarte el
          producto adquirido, brindarte acceso al material descargable y, en
          caso de que lo autorices, enviarte contenido educativo relacionado con
          tu bienestar. Nunca compartimos ni vendemos tus datos personales a
          terceros con fines comerciales.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-43">
          3. Cookies y tecnologías similares
        </h3>
        <p data-id="element-44">
          Este sitio puede utilizar cookies y herramientas de análisis (como
          píxeles de seguimiento) con el objetivo de mejorar la experiencia de
          navegación, medir el rendimiento de la página y optimizar campañas
          publicitarias. Podés desactivar las cookies desde la configuración de
          tu navegador en cualquier momento.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-45">
          4. Seguridad de los datos
        </h3>
        <p data-id="element-46">
          Implementamos medidas razonables para proteger tu información. Los
          pagos son procesados a través de Hotmart, una plataforma reconocida
          internacionalmente, que cumple con los estándares de seguridad PCI DSS
          y utiliza encriptación SSL en todas las transacciones.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-47">5. Tus derechos</h3>
        <p data-id="element-48">
          Tenés derecho a acceder, rectificar o solicitar la eliminación de tus
          datos personales en cualquier momento, conforme a la normativa de
          protección de datos vigente en Argentina (Ley 25.326). Para ejercer
          estos derechos, podés gestionarlo directamente desde tu cuenta de
          Hotmart.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-49">
          6. Cambios en esta política
        </h3>
        <p data-id="element-50">
          Nos reservamos el derecho de actualizar esta política de privacidad
          cuando sea necesario. Cualquier modificación significativa será
          publicada en esta misma página, indicando la fecha de la última
          actualización.
        </p>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-51">
        <p className="text-xs uppercase tracking-wider text-gold font-medium" data-id="element-52">
          Última actualización: Enero 2026
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-53">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-54">
          Al adquirir el Protocolo Anti-Inflamatorio 40+, aceptás estos términos
          y condiciones en su totalidad. Si no estás de acuerdo con alguno de
          los puntos descritos, te pedimos que no realices la compra.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-55">
          2. Naturaleza del producto
        </h3>
        <p data-id="element-56">
          El Protocolo Anti-Inflamatorio 40+ es un producto digital de carácter
          educativo e informativo. No es un tratamiento médico, no reemplaza la
          consulta con profesionales de la salud y no constituye asesoramiento
          médico, nutricional o psicológico individualizado.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-57">
          3. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-58">
          Toda persona que utilice este protocolo lo hace bajo su propia
          responsabilidad. Recomendamos consultar con tu médico de cabecera
          antes de iniciar cualquier cambio en tu alimentación, especialmente si
          tenés condiciones de salud preexistentes, estás embarazada, en período
          de lactancia o tomás medicación de manera regular.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-59">4. Resultados</h3>
        <p data-id="element-60">
          Los resultados mencionados son referenciales y pueden variar de
          persona a persona, ya que dependen de factores individuales como edad,
          estado de salud, adherencia al protocolo, estilo de vida y otros
          factores fisiológicos. No garantizamos resultados específicos.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-61">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-62">
          Todo el contenido del Protocolo Anti-Inflamatorio 40+ —incluyendo
          textos, recetas, guías, imágenes y materiales descargables— está
          protegido por derechos de autor. Queda estrictamente prohibida su
          reproducción, distribución, reventa, modificación o publicación, total
          o parcial, sin autorización expresa por escrito.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-63">
          6. Política de reembolso
        </h3>
        <p data-id="element-64">
          Tu compra está protegida por la garantía de Hotmart. Tenés un plazo de
          7 días corridos desde la fecha de compra para solicitar el reembolso
          directamente desde la plataforma, sin necesidad de justificar el
          motivo.
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-65">
          7. Acceso al contenido
        </h3>
        <p data-id="element-66">
          Una vez confirmado el pago, recibirás el acceso inmediato al material
          digital a través de Hotmart. El acceso es individual, no transferible
          y se otorga de por vida (mientras la plataforma de distribución se
          mantenga operativa).
        </p>

        <h3 className="font-serif text-lg text-teal pt-2" data-id="element-67">8. Modificaciones</h3>
        <p data-id="element-68">
          Nos reservamos el derecho de actualizar o modificar estos términos en
          cualquier momento. Las modificaciones entrarán en vigencia desde el
          momento de su publicación en esta página.
        </p>
      </Modal>
    </>;
}